export const PREVIEW_SCROLL_POSITION_KEY = 'preview-scroll-position' as const